import { isFeatureEnabled } from '../utils/feature-flags';
import { Measurement } from './Configuration';

const FEATURE_ICE_PER_YARD_OPTION = isFeatureEnabled('ice_per_yard_option');

// These match the enum in the backend: https://github.com/sysdynetechnologies/concretego-api/blob/master/ConcreteGo.Api.Batch.Domain/Enum/Batching/IceUnit.cs
export type IceUnitKey = 'kg' | 'kgM3' | 'lb' | 'lbYd3';

type IceUnit = {
  key: IceUnitKey;
  baseUnit: 'kg' | 'lb'; // Unit for calculating ice adjustment
  isCompoundUnit?: boolean; // kg/m3 or lb/yd³
  label: string;
}

type MeasurementType = typeof Measurement[keyof typeof Measurement];

// Ice unit objects with explicit types
const kgUnit: IceUnit = { key: 'kg', label: 'kg', baseUnit: 'kg', isCompoundUnit: false };
const kgM3Unit: IceUnit = { key: 'kgM3', label: 'kg/m³', baseUnit: 'kg', isCompoundUnit: true };
const lbUnit: IceUnit = { key: 'lb', label: 'lb', baseUnit: 'lb', isCompoundUnit: false };
const lbYd3Unit: IceUnit = { key: 'lbYd3', label: 'lb/yd³', baseUnit: 'lb', isCompoundUnit: true };

export const IceUnits: Record<MeasurementType, IceUnit[]> = {
  [Measurement.Metric]: [
    kgUnit,
    ...(FEATURE_ICE_PER_YARD_OPTION ? [kgM3Unit] : []),
  ],
  [Measurement['U.S. Customary']]: [
    lbUnit,
    ...(FEATURE_ICE_PER_YARD_OPTION ? [lbYd3Unit] : []),
  ],
};
